import ConfirmMobile from "../feature/Login/ConfirmMobile"

const ConfirmMobilePage = () => {
    return <ConfirmMobile />
}

export default ConfirmMobilePage